import React, { useEffect, useState, useContext } from "react";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import {
  Button,Typography,TableCell,TableBody,
  TableRow,
  TableHead,
  Table,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box
} from "@mui/material";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Chip from '@mui/material/Chip';
import DashboardContext from "../context/DashboardContext";
import VisibilityIcon from '@mui/icons-material/Visibility';



const options = {
  filterType: "none",
  selectableRows: "none",
  search: true,
  download: false,
  print: false,
  viewColumns: false,
  responsive: 'standard',
  elevation: 2,
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 25, 50],
  searchPlaceholder: 'Search earnings...',
  textLabels: {
    body: {
      noMatch: 'No earnings records found',
    }
  },
  setRowProps: (row, dataIndex, rowIndex) => ({
    style: { 
      cursor: 'pointer', 
      backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#f8fafc' 
    }
  }),
};

const TransactionTable = () => {
  const [popupData, setPopupData] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [data, setData] = useState([]);
  const { sessionUser } = useContext(DashboardContext);

  const handleViewDetails = async (transID) => {
    try {
      const response = await fetch('https://testing.esnep.com/magnessa/api/vendor/transactioninfo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ComID: "EH25",
          UserID: sessionUser.UserID,
          Flag: "SI",
          TransID: transID,
          ReferenceID: sessionUser.Username,  
          AuthCode: sessionUser.AuthCode
        }),
      });
      
      const data = await response.json();
      setPopupData(data);
      setOpenPopup(true);
    } catch (error) {
      console.error('API Error:', error);
    }
  };



  
  const columns = [

    { 
      
      name: "TransDate", 
      label: "Transaction Date",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
        customBodyRender: (value) => value.split(" ")[0] // Extracts only the date
      },
    },

    { 
      name: "TransID", 
      label: "Transaction ID",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
      },
    },
    { 
      name: "NoProduct", 
      label: "No. of Product",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
      }
    },
    { 
      name: "TotalAmt", 
      label: "Price",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
        customBodyRender: (value) => (
          <span style={{ fontWeight: 600, color: '#16a34a' }}>
            {parseFloat(value).toFixed(2)}
          </span>
        )
      },
    },




    { 
      name: "TotalPV", 
      label: "PV",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
        customBodyRender: (value) => (
          <span style={{ color: '#3b82f6' }}>
            {parseFloat(value).toFixed(2)}
          </span>
        )
      },
    },

    {
      name: "TransStatus",
      label: "Status",
      options: { 
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
        customBodyRender: (value) => {
          const statusConfig = {
            Pending: {
              color: '#f59e0b',
              bgColor: '#fffbeb'
            },
            Approved: {
              color: '#10b981',
              bgColor: '#ecfdf5'
            },
            Rejected: {
              color: '#ef4444',
              bgColor: '#fef2f2'
            }
          };
    
          const { color, bgColor } = statusConfig[value] || { color: '#64748b', bgColor: '#f8fafc' };
    
          return (
            <span style={{
              color: color,
              backgroundColor: bgColor,
              padding: '4px 10px',
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: 600,
              display: 'inline-block',
              whiteSpace: 'nowrap'
            }}>
              {value}
            </span>
          );
        }
      }
    },


    {
      name: "",
      label: "ACTION",
      options: { 
        filter: false,
        sort: false,
        setCellHeaderProps: () => ({
          style: { 
            fontWeight: 600, 
            backgroundColor: '#f8fafc',
            fontSize: "0.75rem",
            color: '#64748b',
            padding: '10px 16px',
          },
        }),
        customBodyRender: (value, tableMeta) => (
          <IconButton 
            onClick={() => handleViewDetails(tableMeta.rowData[1])} // TransID is index 0
            size="small"
            sx={{ p: '4px', color: '#64748b' }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        )
      },
    },
  ];
  
  const DetailItem = ({ label, value }) => (
    <div style={{ marginBottom: 8 }}>
      <span style={{ color: '#64748b', fontSize: '0.875rem' }}>{label}: </span>
      <span style={{ fontWeight: 500, color: '#1e293b' }}>{value}</span>
    </div>
  );


  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestBody = {
          ComID: "EH25",
          UserID: sessionUser.UserID,
          Flag: "S",
          TransStatus: "-1",
          FromDate: "2024-06-01",
          ToDate: "2025-06-01",
          ReferenceID: sessionUser.Username,
          AuthCode: sessionUser.AuthCode,
        };
  
        const response = await axios.post(
          "https://testing.esnep.com/magnessa/api/vendor/transaction",
          requestBody,
          { headers: { "Content-Type": "application/json" } }
        );
  
        if (response.data && response.data.ProdLst) {
          setData(response.data.ProdLst);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, []);

  return (
    <>
      <MUIDataTable 
        title={
          <Typography variant="h6" sx={{ 
            px: 1,
            py: 0,
            color: '#1e293b',
            fontSize: '1.125rem',
            fontWeight: 600
          }}>
            Transaction Data
          </Typography>
        } 
        data={data} 
        columns={columns} 
        options={options} 
      />

<Dialog open={openPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
  <DialogTitle sx={{ 
    bgcolor: 'primary.main', 
    color: 'white',
    py: 2,
    fontSize: '1.25rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: 1
  }}>
    <ReceiptLongIcon fontSize="small" />
    Transaction Details
  </DialogTitle>

  <DialogContent sx={{ pt: 3, px: 3 }}>
    {popupData?.ProdLst?.map((transaction, index) => (
      <div key={index}>
        {/* Header Section */}
        <Box sx={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(2, 1fr)', 
          gap: 2, 
          mb: 3,
          p: 2,
          borderRadius: 1,
          bgcolor: 'grey.50'
        }}>
          <Box>
            <DetailItem 
              label="Transaction ID" 
              value={transaction.TransID} 
              labelProps={{ color: 'text.secondary' }}
              valueProps={{ fontWeight: 600 }}
            />
            <DetailItem 
              label="Date" 
              value={transaction.TransDate} 
              labelProps={{ color: 'text.secondary' }}
            />
            <DetailItem 
              label="Customer" 
              value={transaction.FullName} 
              labelProps={{ color: 'text.secondary' }}
              valueProps={{ fontWeight: 500 }}
            />
          </Box>
          <Box>
            <DetailItem 
              label="Total Amount" 
              value={`${transaction.TotalAmt.toFixed(4)}`} 
              labelProps={{ color: 'text.secondary' }}
              valueProps={{ color: 'primary.main', fontWeight: 600 }}
            />
            <DetailItem 
              label="Total PV" 
              value={transaction.TotalPV} 
              labelProps={{ color: 'text.secondary' }}
            />
            <Chip 
              label={transaction.TransStatus} 
              color={transaction.TransStatus === 'Completed' ? 'success' : 'warning'}
              size="small"
              sx={{ mt: 1 }}
            />
          </Box>
        </Box>

        {/* Products Table */}
        <Table size="small" sx={{ 
          mb: 3,
          border: '1px solid',
          borderColor: 'grey.200',
          borderRadius: 1,
          overflow: 'hidden',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
          <TableHead sx={{ bgcolor: 'primary.light' }}>
            <TableRow>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Product ID</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 600 }}>Product Name</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Quantity</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Rate</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transaction.ProdInfo.map((product, idx) => (
              <TableRow key={idx} sx={{ '&:nth-of-type(odd)': { bgcolor: 'grey.50' } }}>
                <TableCell>{product.ProdID}</TableCell>
                <TableCell sx={{ fontWeight: 500 }}>{product.ProdName}</TableCell>
                <TableCell align="right" sx={{ color: 'primary.main' }}>{product.ProdQty}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 500 }}>
                  {product.ProdRate.toFixed(4)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {/* Order Info */}
        <Box sx={{ 
          display: 'flex', 
          gap: 3,
          p: 2,
          bgcolor: 'grey.50',
          borderRadius: 1,
          mt: 2
        }}>
          <DetailItem 
            label="Order Date" 
            value={transaction.OrderInfo[0]?.OrderDate} 
            labelProps={{ color: 'text.secondary' }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Order Status
            </Typography>
            <Box sx={{ 
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              color: transaction.OrderInfo[0]?.OrderStatus === 'Delivered' ? 'success.main' : 'warning.main'
            }}>
              <FiberManualRecordIcon fontSize="small" />
              <Typography variant="body2" fontWeight={500}>
                {transaction.OrderInfo[0]?.OrderStatus}
              </Typography>
            </Box>
          </Box>
        </Box>
      </div>
    ))}
  </DialogContent>

  <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'grey.200' }}>
    <Button 
      onClick={() => setOpenPopup(false)} 
      variant="contained"
      sx={{
        textTransform: 'none',
        px: 3,
        py: 1,
        borderRadius: 2,
        boxShadow: 'none',
        '&:hover': { boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }
      }}
    >
      Close Details
    </Button>
  </DialogActions>
</Dialog>
    </>
  );
};

export default TransactionTable;